import * as actionTypes from './actionTypes';
import { serviceTemplate } from './service';
import { TemplateModel } from '@app/src/view/Loading/template/model/TemplateModel';

const fetchTemplateRequest = () => ({
  type: actionTypes.FETCH_TEMPLATE_REQUEST
});

const fetchTemplateFailure = (errorMessage: string, status: number) => ({
  type: actionTypes.FETCH_TEMPLATE_FAILURE,
  errorMessage,
  status
});

const fetchTemplateSuccess = (data: TemplateModel) => ({
  type: actionTypes.FETCH_TEMPLATE_SUCCESS,
  data
});

export const fetchTemplate = (urlPath: string): Function => {
  return async dispatch => {
    dispatch(fetchTemplateRequest());
    try {
      const token: string = getToken(urlPath);
      const data: TemplateModel = await serviceTemplate.getData(token);
      dispatch(fetchTemplateSuccess(data));
    } catch(e) {
      dispatch(fetchTemplateFailure(e.message, e.status));
    }
  }
};

const getToken = (urlPath: string): string => {
  return urlPath.substr(1).split('.html')[0];
}
